export class AwsCassandraClusterRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "keepOriginalTags",
            "baseName": "keepOriginalTags",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "instanceProfileName",
            "baseName": "instanceProfileName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsCassandraClusterRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
